// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: true,
    baseUrlWs: (window.location.origin === 'https://portal.quincy-data.com') ? 'https://portal.quincy-data.com/backend' : 'https://portal.mckay-brothers.com/backend',
    portalUrl: 'https://portal-sf1.mckay-brothers.com',
    cookieDomain : (window.location.origin === 'https://portal.quincy-data.com') ? '.quincy-data.com' : '.mckay-brothers.com',
    sf1CookieName : 'McKaySession',
    resizeIFrame: true,   // resize iframe, need to be on the same domain
    // SCARF_ANALYTICS=false,
    // SCARF_ANALYTICS=false,
    bwmUrl: 'http://hub.infra.mckay-brothers.com/projects/bwm',
    mckayDomaine: 'https://portal.mckay-brothers.com',   // resize iframe, need to be on the same domain
    mckayBrand: 'Mckay Brothers',   // resize iframe, need to be on the same domain
    quincyDomaine: 'https://portal.quincy-data.com',   // resize iframe, need to be on the same domain
    quincyBrand: 'Quincy Data',
    mfaMethod: 'google_authenticator',
    loaUrl: 'https://hub.infra.mckay-brothers.com/projects/loa',
    apiDevKeyWindy: 'Pz4cbwgeMeX0jE7kzqPcSVAJqb0V7yDB', // this is a trail key and need to be updated
    apiProdKeyWindy: 'zZ1oWl7sDohQYdYh6HR53HIb5eNIXy0G',
    circuitMarsHubBaseLink : 'https://hub.infra.mckay-brothers.com/projects/mars_ng6/#/circuits/customer/',
    bwmEtreeUrl : 'https://hub.infra.mckay-brothers.com/projects/bwm/#/etree-edit/',
    subCookiesDomain: 'prod-portal',
    displayJiraFeature : true,
    hostingManagerUrl: 'https://hub.infra.mckay-brothers.com/projects/hosting_manager/#',
    mdmUrl: 'https://hub.infra.mckay-brothers.com/projects/mdm',
    displayCageNameForClient: true,
    clfProductId: "216d3fe0-3bd6-9f17-3750-3c8de2070b5a",
    displayPopConfigForClient: false,
    displayClfLedgerForClient: false,
};
